export const getTokensState = async (user) => {
    // const response = await fetch('https://api.lipshitz.ai/tokens', {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({email: user.email}),
    // });


    const data = {
        tokensLeft: 20,
        tokensTotal: 200,
    }; // await response.json();
    return data
}
